<template>
  <div class="animated fadeIn">
    <loading
      v-if="loading"
      message="Загружаем информацию о техцентре..."/>
    <loading
      v-else-if="saving"
      message="Сохраняем информацию о техцентре..."/>
    <div
      v-else
      class="row">
      <div class="col-12 col-xl-6">
        <div class="card">
          <form сlass="form-horizontal">
            <div class="card-header">Основная информация</div>
            <div class="card-block">
              <div class="col-12">
                <tc-check-box v-model="newDataItem.enabled"/>
                <!--Company name-->
                <tc-input
                  v-model="newDataItem.name"
                  :label-text="'Название'"
                  :label-id="'inputName'"
                  :input-require="true"
                  :error="$v.newDataItem.name.$error"
                  :error-text="'Название обязательно должно быть указано, минимум 2 символа'"
                  @input="$v.newDataItem.name.$touch()"/>
                <!--Company selecting-->
                <tc-select-company
                  v-model="newDataItem.companyId"
                  :company="techcenter.company"
                  :error="$v.newDataItem.companyId.$error"
                  @input="$v.newDataItem.cityId.$touch()"
                />
                <tc-select-users
                  v-model="newDataItem.users"
                  :users-objects="usersObjects"/>
                <!--City selecting-->
                <tc-select-city
                  v-model="newDataItem.cityId"
                  :city="techcenter.city"
                  :error="$v.newDataItem.cityId.$error"
                  @input="$v.newDataItem.cityId.$touch()"
                />
                <!--Address input-->
                <tc-input
                  :label-text="'Адрес'"
                  :label-id="'inputAddress'"
                  :input-require="true"
                  :error="$v.newDataItem.address.$error"
                  :error-text="'Адрес обязательно должен быть указан, минимум 2 символа'"
                  v-model="newDataItem.address"
                  class="mb-0"
                  @input="$v.newDataItem.address.$touch()"/>
                <tc-map
                  class="mb-1"
                  style="margin-top: 4px; "
                  v-model="newDataItem.coords"
                  :address="newDataItem.address"
                  :city-id="newDataItem.cityId"/>
                <!--Phone input-->
                <tc-input-phone
                  v-model="newDataItem.phone"
                  :error="$v.newDataItem.phone.$error"
                  @input="$v.newDataItem.phone.$touch()"/>
                <tc-input
                  v-model="newDataItem.maxOrders"
                  :label-text="'Максимальное число заказов'"
                  :label-id="'inputMaxOrders'"
                  :input-require="true"
                  :error="$v.newDataItem.maxOrders.$error"
                  :error-text="'Введите максимальное число заказов'"
                  input-type="number"/>
                <tc-partnership
                  v-model="partnership"
                  class="mb-1"/>
                <tc-color-picker
                  v-model="newDataItem.color"
                  class="mb-1"/>
                <tc-select-time-zone v-model="newDataItem.tzOffset"/>
                <!--TODO -->
                <tc-select-work-time
                  v-if="false"
                  v-model="schedule"/>
                <div class="form-group row">
                  <label class="col-4 form-control-label">График работы</label>
                  <div class="col-8">
                    <div class="row">
                      <div class="form-group col-6">
                        <select class="form-control" v-model="newDataItem.workDateStart">
                          <option v-for="item in workDates" :value="item.id">{{item.name}}</option>
                        </select>
                      </div>
                      <div class="form-group col-6">
                        <select class="form-control" v-model="newDataItem.workDateEnd">
                          <option v-for="item in workDates" :value="item.id">{{item.name}}</option>
                        </select>
                      </div>
                      <div class="form-group col-6">
                        <select class="form-control" v-model="newDataItem.workTimeStart">
                          <option v-for="item in workTimes" :value="item.id">{{item.name}}</option>
                        </select>
                      </div>
                      <div class="form-group col-6">
                        <select class="form-control" v-model="newDataItem.workTimeEnd">
                          <option v-for="item in workTimes" :value="item.id">{{item.name}}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <tc-add-images
                  class="mt-1 mb-1"
                  v-model="newDataItem.images"/>
                <tc-input
                  :label-text="'Ссылка на схему проезда'"
                  :label-id="'inputTransitLink'"
                  :error="$v.newDataItem.link.$error"
                  :error-text="'Ссылка должна быть указана'"
                  v-model="newDataItem.link"
                  @input="$v.newDataItem.link.$touch()"/>
                <tc-text-area v-model="newDataItem.description"/>
                <tc-input-advantages v-if="false"/>
              </div>
            </div>
            <div class="card-footer">
              <button
                v-if="!loading"
                type="button"
                class="btn btn-success"
                @click.prevent="beforeUpdateForm">
                <template v-if="techcenter">Сохранить изменения</template>
                <template v-else>Добавить техцентр</template>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import marked from 'marked'
import { required, minLength, url, numeric, maxLength } from 'vuelidate/lib/validators'
import addTechcenterMutate from './../../gql/mutations/AddTechcenter.graphql'
import updateTechcenterMutate from './../../gql/mutations/UpdateTechcenter.graphql'
import { mapState, mapActions } from 'vuex'
import { ADD_TOAST_MESSAGE } from 'vuex-toast'
import moment from 'moment'
import TcInput from './components/TcInput'
import TcSelectCity from './components/TcSelectCity'
import TcSelectTimeZone from './components/TcSelectTimeZone'
import TcSelectWorkTime from './components/TcSelectWorkTime'
import TcInputPhone from './components/TcInputPhone'
import TcAddImages from './components/TcAddImages'
import TcTextArea from './components/TcTextArea'
import TcMap from './components/TcMap'
import TcCheckBox from './components/TcCheckBox'
import TcSelectCompany from './components/TcSelectCompany'
import TcSelectUsers from './components/TcSelectUsers'
import TcInputAdvantages from './components/TcInputAdvantages'
import TcPartnership from './components/TcPartnership'
import TcColorPicker from './components/TcColorPicker'
// TODO потом удалить
import {workDates} from '../../helpers/workDates'
import workTimes from '../../helpers/workTimes'

export default {
  computed: {
    compiledMarkdown: function () {
      if (this.techcenter.description) {
        return marked(this.techcenter.description, { sanitize: true })
      }
      return '<div class="alert alert-danger">Описание не заполнено</div>'
    },
    partnership: {
      get: function () {
        return {
          commissionInstall: this.newDataItem.commissionInstall,
          commissionReclamation: this.newDataItem.commissionReclamation,
          commissionRetail: this.newDataItem.commissionRetail
        }
      },
      set: function (obj) {
        this.changePartnership(obj)
      }
    },
    ...mapState({
      techcenter: state => state.techcenterStore.techcenter,
      cities: state => state.globalStore.cities
    })
  },
  watch: {
    '$route': 'loadTechcenterData'
  },
  components: {
    TcColorPicker,
    TcPartnership,
    TcInputAdvantages,
    TcSelectUsers,
    TcSelectCompany,
    TcCheckBox,
    TcMap,
    TcTextArea,
    TcAddImages,
    TcInputPhone,
    TcSelectWorkTime,
    TcSelectCity,
    TcInput,
    TcSelectTimeZone
  },
  data () {
    return {
      loading: false,
      saving: false,
      newDataItem: {},
      // TODO schedule должен быть в таком виде в newDataItem
      schedule: [
        {
          id: 0,
          dayIds: [
            2,
            3,
            4
          ],
          timeStart: '07:00:00',
          timeEnd: '22:00:00'
        },
        {
          id: 1,
          dayIds: [
            5,
            6
          ],
          timeStart: '00:00:00',
          timeEnd: '00:00:00'
        },
        {
          id: 2,
          dayIds: [
            1,
            7
          ],
          timeStart: '16:00:00',
          timeEnd: '22:00:00'
        }
      ],
      usersObjects: [],
      // TODO потом удалить
      workDates: workDates(),
      workTimes: workTimes()
    }
  },
  methods: {
    loadTechcenterData () {
      this.loading = true
      this.id = this.$route.params.id
      this.$store.dispatch('getTechcenterById', {id: this.id, imgWidth: 240, imgHeight: 120})
        .then(() => {
          this.setNewDataItem()
          this.loading = false
        })
        .catch((error) => {
          this.addToast({
            text: 'Произошла ошибка:' + error,
            type: 'danger',
            dismissAfter: 10000
          })
        })
    },
    setNewDataItem () {
      const item = this.techcenter
      this.newDataItem = Object.assign({}, item)
      delete this.newDataItem.city
      delete this.newDataItem.company
      this.newDataItem.cityId = item.city.id
      this.newDataItem.companyId = item.company.id
      this.newDataItem.users = item.users.map(user => {
        return user.id
      })
      this.usersObjects = item.users
      this.newDataItem.workTimeEnd = moment(item.workTimeEnd, 'HH:mm').format('HH:mm:ss').toString()
      this.newDataItem.workTimeStart = moment(item.workTimeStart, 'HH:mm').format('HH:mm:ss').toString()
    },
    beforeUpdateForm () {
      this.$v.newDataItem.$touch()
      if (this.$v.newDataItem.$error) {
        return
      }
      if (this.$route.params.id) {
        this.updateItem()
      } else {
        this.addItem()
      }
    },
    addItem () {
      this.saving = true
      this.$apollo.mutate({
        mutation: addTechcenterMutate,
        variables: this.newDataItem
      }).then((result) => {
        this.saving = false
        this.addToast({
          text: 'Техцентр успешно добавлен',
          type: 'success',
          dismissAfter: 3000
        })
        this.$router.push({ name: 'Techcenter', params: { id: result.data.addTechcenter.id } })
      }).catch((error) => {
        console.error(error)
        this.addToast({
          text: 'Произошла ошибка:' + error,
          type: 'danger',
          dismissAfter: 10000
        })
        this.saving = false
      })
    },
    updateItem () {
      this.saving = true
      this.$apollo.mutate({
        mutation: updateTechcenterMutate,
        variables: this.newDataItem
      }).then((result) => {
        this.saving = false
        this.addToast({
          text: 'Техцентр успешно обновлен',
          type: 'success',
          dismissAfter: 3000
        })
        this.$store.commit('SET_TECHCENTER', result.data.updateTechcenter)
        this.setNewDataItem()
      }).catch((error) => {
        this.addToast({
          text: 'Произошла ошибка:' + error,
          type: 'danger',
          dismissAfter: 10000
        })
        this.saving = false
      })
    },
    changePartnership (obj) {
      this.newDataItem.commissionInstall = obj.commissionInstall
      this.newDataItem.commissionReclamation = obj.commissionReclamation
      this.newDataItem.commissionRetail = obj.commissionRetail
    },
    clearData () {
      this.newDataItem = {
        id: null,
        name: '',
        enabled: true,
        cityId: 1,
        companyId: null,
        address: '',
        link: '',
        color: '#BF4040',
        users: [],
        workDateStart: 1,
        workDateEnd: 7,
        workTimeStart: '10:00:00',
        workTimeEnd: '20:00:00',
        commissionReclamation: 40,
        commissionInstall: 40,
        commissionRetail: 50,
        maxOrders: 2,
        tzOffset: 'Europe/Moscow',
        description: '',
        coords: ''
      }
      this.$v.newDataItem.$reset()
      this.$store.commit('CLEAR_TECHCENTER_DATA')
    },
    ...mapActions({
      addToast: ADD_TOAST_MESSAGE
    })
  },

  validations: {
    newDataItem: {
      name: {
        required,
        minLength: minLength(2)
      },
      cityId: {
        numeric,
        required
      },
      companyId: {
        required
      },
      address: {
        required,
        minLength: minLength(2)
      },
      phone: {
        required,
        numeric,
        maxLength: maxLength(10),
        minLength: minLength(10)
      },
      link: {
        required,
        url
      },
      maxOrders: {
        required,
        numeric
      },
      commissionReclamation: {
        required,
        numeric
      },
      commissionInstall: {
        required,
        numeric
      },
      commissionRetail: {
        required,
        numeric
      }
    }
  },
  created () {
    if (this.$route.params.id) {
      this.loadTechcenterData()
    } else {
      this.clearData()
    }
  }
}
</script>



// WEBPACK FOOTER //
// Edit.vue?a9ac405c